import { methods } from '@/utils/methods'

// お知らせ情報

const state = () => ({
  // 一覧情報
  list: [],
  // 詳細情報
  detail: []
})

const getters = {
  list: (state) => state.list,
  detail: (state) => state.detail
}

const mutations = {
  list(state, list) {
    state.list = list
  },
  detail(state, detail) {
    state.detail = detail
  }
}

const actions = {
  // 一覧取得
  async list({ commit }, params = {}) {
    const res = await this.$axios.get(methods.getApiBaseUrl() + '/notices', {
      params
    })
    commit('list', res.data)
  },
  // 詳細取得
  async detail({ commit }, { id, params }) {
    const res = await this.$axios.get(
      methods.getApiBaseUrl() + '/notices/' + id,
      {
        params,
        validateStatus(status) {
          return status < 500
        }
      }
    )
    if (res.status && res.status === 404) {
      return
    }
    commit('detail', res.data)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
